// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unassignedItems[data-v-561fa7bf]{max-height:190px;overflow-y:scroll}.assignedItems[data-v-561fa7bf]{max-height:150px;overflow-y:scroll}.entityMenuContent[data-v-561fa7bf]{max-width:-webkit-min-content;max-width:-moz-min-content;max-width:min-content}", ""]);
// Exports
module.exports = exports;
